import styled from 'styled-components';
import globalTheme from '@ui/theme';
import { makeExternalUrl, trackAnalyticsNew, toSlug } from '../../../../lib/utils';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import { DATA_TRACK_TYPE_CTA, DOM_BUTTON } from '../../../../lib/constants';
import Button from '../Button/Button';

const InfoSectionContainerDiv = styled.div`
  background-color: ${(p) => p.backgroundColor};
`;

const InfoSectionContentDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${(p) => (p.isMobile ? 'column-reverse' : (p.direction === 'LEFT' ? 'row-reverse' : 'row'))};
  gap: ${({ theme }) => theme.unit(6)};

  padding: ${({ theme }) => theme.unit(6)} 0;
  
  @media (min-width: ${(p) => p.theme.minWidthBreakpoint.tablet}px) {
    padding: ${({ theme }) => theme.unit(8)} 0;
  }
  
  @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
    padding: ${({ theme }) => theme.unit(10)} 0;
    gap: ${({ theme }) => theme.unit(8)};
  }
`;

const InfoSectionTextContentDiv = styled.div`
`;

const InfoSectionImageDiv = styled.div`
  width: 100%;
  flex-shrink: 0;
  text-align: center;

  @media (min-width: ${(p) => p.theme.minWidthBreakpoint.tablet}px) {
    width: auto;
    max-width: 50%;
  }
`;

const InfoSectionTitleDiv = styled.h2`
  ${({ theme }) => theme.typographyRebrand.heading['2xl']}
  color: ${({ theme }) => theme.c.text.primary};
  margin: 0;
`;

const InfoSectionSubtitleDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.lg}
  color: ${(p) => p.theme.c.text.primary};
  margin-top: ${(p) => p.theme.unit(1)};
`;

const InfoSectionButtonDiv = styled.div`
  margin-top: ${({ theme }) => theme.unit(3)};
  width: ${(p) => (p.isMobile ? '100%' : 'fit-content')};
`;

const InfoSectionImg = styled.img`
  max-width: 100%;
  height: auto;
  object-fit: contain;

  @media (min-width: ${(p) => p.theme.minWidthBreakpoint.tablet}px) {
    max-height: ${({ theme }) => theme.unit(55)};
  }
`;

const HowItWorksInfoSection = (props) => {
  const {
    sectionData = {},
    isMobile = false,
    backgroundColor = globalTheme.c.bg.primary,
  } = props;

  const {
    name = '',
    title = '',
    subtitle = '',
    imageUrl = '',
    imageAlignment = '',
    buttonTagSet = {},
    buttonText = '',
    buttonDescriptiveText,
    buttonUrl = '',
  } = sectionData;

  const imageUrlToUse = makeExternalUrl(imageUrl);

  return (
    <InfoSectionContainerDiv backgroundColor={backgroundColor}>
      <MaxWidthLayout>
        <InfoSectionContentDiv direction={imageAlignment} isMobile={isMobile}>
          <InfoSectionTextContentDiv isMobile={isMobile}>
            <InfoSectionTitleDiv isMobile={isMobile}>
              { title }
            </InfoSectionTitleDiv>
            <InfoSectionSubtitleDiv isMobile={isMobile}>
              { subtitle }
            </InfoSectionSubtitleDiv>
            {buttonText && buttonUrl && (
              <InfoSectionButtonDiv isMobile={isMobile}>
                <Button
                  buttonText={buttonText}
                  variant="primary"
                  size="medium"
                  accessibleLabel={buttonDescriptiveText}
                  {...trackAnalyticsNew({
                    url: buttonUrl,
                    location: toSlug(name),
                    name: `${DOM_BUTTON}:${toSlug(buttonText)}`,
                    tags: buttonTagSet,
                  })}
                  dataTrackType={DATA_TRACK_TYPE_CTA}
                />
              </InfoSectionButtonDiv>
            )}
          </InfoSectionTextContentDiv>
          <InfoSectionImageDiv isMobile={isMobile}>
            <InfoSectionImg src={imageUrlToUse} alt="" isMobile={isMobile} />
          </InfoSectionImageDiv>
        </InfoSectionContentDiv>
      </MaxWidthLayout>
    </InfoSectionContainerDiv>
  );
};

export default HowItWorksInfoSection;
